import { FC, ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import { GHeader } from '../../components/Guest/GHeader'
import { GFooter } from '../../components/Guest/GFooter'
import { CookieConsentBanner } from '../../components/Guest/CookieConsentBanner'
import { Box } from '@mui/material'
import { StyledBox, StyledContainer } from './style'
import { AppContainer } from '../../components/ui-kit/AppContainer'

interface GuestLayoutProps {
  children?: ReactNode
}

const GuestLayout: FC<GuestLayoutProps> = ({ children }) => {
  return (
    <Box sx={StyledBox}>
      <GHeader />
      <AppContainer sx={{ ...StyledContainer, flexGrow: 1 }}>
        {children || <Outlet />}
      </AppContainer>
      <GFooter />
      <CookieConsentBanner />
    </Box>
  )
}

export default GuestLayout
